import { inject, Pipe, PipeTransform } from '@angular/core';
import { SKWMessageData } from '../services/storekeeper-window-message.service';
import { SKWTranslateService } from '../services/storekeeper-window-translate.service';

@Pipe({ name: 'SKWTranslate', standalone: true })
export class SKWTranslatePipe implements PipeTransform {
  #SKWTranslateService = inject(SKWTranslateService);

  transform(key: SKWMessageData['content']): string {
    return this.#SKWTranslateService.getTranslation(key as string);
  }
}
